import { createAction } from '@ngrx/store';

export const appPreInitializing = createAction('[APP CORE] (App) Pre-Initializing');
export const appPreInitialized = createAction('[APP CORE] (App) Pre-Initialized');

export const appInitializing = createAction('[APP CORE] (App) Initializing');
export const appInitialized = createAction('[APP CORE] (App) Initialized');
